import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export interface OpenPreviewPanelCommandProperties extends CommandProperties {
  url: string;
  ari: string;
}

export const OpenPreviewPanelCommand =
  createCommand<OpenPreviewPanelCommandProperties>('open-preview-panel');
